import { UseQueryModalReturn } from "../../types";

interface UseTextQueryModalParams {
  inputValue: string | null;
  previousValue?: string | null;
  editQueryId?: string;
}

export function useTextQueryModal({
  inputValue,
  previousValue,
  editQueryId,
}: UseTextQueryModalParams): UseQueryModalReturn {
  const isSubmitDisabled =
    inputValue?.length === 0 || !!(editQueryId && inputValue === previousValue);
  return { isSubmitDisabled };
}
